import { Axios, AxiosRequestConfig } from 'axios';
/**
 * 接口请求行为  created by 王大盼
 * @param axios 2022-01-11
 * @returns
 */
function httpAction(axios: Axios) {
    const getBind = axios.get.bind(axios);
    const postBind = axios.post.bind(axios);
    function get<T>(url: string, data?: any, configs?: AxiosRequestConfig): Promise<T> {
        const action = (): Promise<T> => {
            let config: AxiosRequestConfig = {};
            if (data) {
                config = {
                    params: data,
                    ...config,
                    ...configs,
                };
            }
            return getBind(url, config);
        };
        return action();
    }
    function post<T>(url: string, data: any, config?: AxiosRequestConfig): Promise<T> {
        const action = (): Promise<T> => {
            return postBind(url, data, config);
        };
        return action();
    }

    return {
        get,
        post,
    };
}

export default httpAction;

